import { Popover } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import { middleLeft } from 'core/elements/menu/defaults'
import Text from 'core/elements/Text'
import Tooltip from 'core/elements/tooltip/Tooltip'
import Theme from 'core/themes/model'
import React from 'react'

type ActionItem = {
  label: string
  icon: string
  onClick: () => void
  disabled?: boolean
  tooltipMessage?: string
}

type CommonActionPopoverProps = {
  open: boolean
  setOpen: (value: boolean) => void
  anchorEl: HTMLElement | null
  actions: ActionItem[]
}

const CommonActionPopover: React.FC<CommonActionPopoverProps> = ({
  open,
  setOpen,
  anchorEl,
  actions,
}) => {
  const classes = useStyles()

  return (
    <Popover
      open={open}
      onClose={() => setOpen(false)}
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <div className={classes.settingsMenuContainer}>
        {actions.map(({ label, icon, onClick, disabled, tooltipMessage }, index) => (
          <Tooltip key={index} message={disabled ? tooltipMessage : null} align={middleLeft.align}>
            <Text
              variant="body2"
              className={clsx(classes.settingsMenuItem, {
                [classes.disabled]: disabled,
              })}
              onClick={() => {
                if (!disabled) {
                  setOpen(false)
                  onClick()
                }
              }}
            >
              <FontAwesomeIcon size="md">{icon}</FontAwesomeIcon>
              {label}
            </Text>
          </Tooltip>
        ))}
      </div>
    </Popover>
  )
}

export default CommonActionPopover

const useStyles = makeStyles<Theme>((theme) => ({
  settingsMenuContainer: {
    padding: '8px 0',
    width: '154px',
  },
  settingsMenuItem: {
    display: 'grid',
    gridTemplateColumns: 'max-content 1fr',
    alignItems: 'center',
    gap: 6,
    padding: '8px 16px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.grey[50],
    },
  },
  disabled: {
    cursor: 'not-allowed',
    pointerEvents: 'none',
    color: '#ccc',
    '& i': {
      color: theme.palette.grey[300],
    },
  },
}))
